<template>
    <div class="row">
        <div class="col-12">
            <div class="form-group mb-3">
                <input type="text" class="form-control bordered small-input" :placeholder="$t('partido.buscar') + '...'" v-model="search"/>
            </div>
        </div>
        <div class="col-12 tabla-sectores">
            <table class="table table-hover text-nowrap">
                <thead>
                    <tr>
                        <th></th>
                        <th>{{ $t('general.sector') }}</th>
                        <th v-if="teatro.hash !== 'J1fKG9AarPuPNJ5hwY0t' && !mostrar_precio_mas_alto_en_la_zona">{{ $t('general.desde') }}</th>
                        <th v-else></th>
                        <th>{{ $t('general.libres') }}</th>
                    </tr>
                </thead>
                <tbody v-if="zonas">
                    <tr 
                        v-for="(zona, index) in search_zonas"
                        :id="'zona-tabla-' + zona.id" 
                        :key="index"
                        :class="{'highlighted-table': zona.id === hovered_zona_id}"
                        @mouseenter="$emit('zoneHover', zona.id, true)"
                        @mouseleave="$emit('zoneHover', zona.id, false)"
                        @click="goTo(zona)"
                    >
                        <td :style='"background-color: " + zona.color'></td>
                        <td>{{ zona.name }}</td>
                        <template v-if="teatro.hash !== 'J1fKG9AarPuPNJ5hwY0t'">
                            <td v-if="!mostrar_precio_mas_alto_en_la_zona">{{ zona.precios.length > 0 ? zona.precios[0].precio : 0 | formatear_precio }}</td>
                            <td v-else>{{ zona.precios.length > 0 ? zona.precios[zona.precios.length - 1].precio : 0 | formatear_precio }}</td>
                        </template>
                        <td v-else></td>
                        <td class="text-center">{{ aforo(zona) }}</td>
                    </tr>
                </tbody>
                <tbody v-else>
                    <tr>
                        <td colspan="4">
                            <LoaderComponent/>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['zonas', 'hovered_zona_id'],
        data() {
            return {
                search: '',
                mostrar_precio_mas_alto_en_la_zona: this.$store.getters.getTeatro.mostrar_precio_mas_alto_en_la_zona
            }
        },
        computed: {
            search_zonas : function() {
                var zonas = [];

                for(var i in this.zonas) {
                    if(this.zonas[i].esta_disponible) {
                        if(this.zonas[i].name.toLowerCase().indexOf(this.search.toLowerCase()) > -1) {
                            zonas.push(this.zonas[i]);
                        }
                    }

                }

                return zonas;
            },
            teatro(){
                return this.$store.getters.getTeatro;
            }
        },
        methods: {
            goTo(zona) {
                this.$emit('goTo', zona);
            },
            aforo(zona) {
                if(zona.with_seats === 0) {
                    return '';
                }

                return zona.libres
            }
        }
    }
</script>

<style>
    .tabla-sectores {
        overflow: scroll;
        height: 400px;
    }
    tr.highlighted-table {
        background-color: var(--alttextcolor);
        color: var(--altcolor);
        border: 1.5px solid var(--altcolor);
        font-weight: bold;
        cursor: pointer;
        transition: background-color 0.2s ease;
    }
</style>
